import React from "react";
import { useHistory, Route } from "react-router-dom";
import { PageSettings } from "./../../config/page-settings.js";
import SidebarNavList from "./sidebar-nav-list.jsx";
import menus from "./menu.jsx";

import { useAuth } from "../content/auth.jsx";

import menus_cliente from "./menu_cliente.jsx";
import menus_admin from "./menu_admin.jsx";
import menus_po from "./menu_po.jsx";
import menus_disaan from "./menu_disaan.jsx";
import menus_asesoria from "./menu_asesoria.jsx";
import menus_tecnico from "./menu_tecnico.jsx";
import menus_cuarentena from "./menu_cuarentena.jsx";
import menus_medico from "./menu_medico.jsx";
class SidebarNav extends React.Component {
  static contextType = PageSettings;

  constructor(props) {
    super(props);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }
	
    switch (localStorage.nivel_actual) {
      case "2":
        this.state = {
          active: -1,
          clicked: -1,
          menus: menus_admin,
        };
        break;
      case "3":
        this.state = {
          active: -1,
          clicked: -1,
          menus: menus_po,
        };
        break;
      case "4":
        this.state = {
          active: -1,
          clicked: -1,
          menus: menus_asesoria,
        };
        break;
      case "5":
        this.state = {
          active: -1,
          clicked: -1,
          menus: menus_tecnico,
        };
        break;
      case "6":
        this.state = {
          active: -1,
          clicked: -1,
          menus: menus_cuarentena,
        };
        break;  
      case "7":
      this.state = {
        active: -1,
        clicked: -1,
        menus: menus_medico,
        };
        break;
      case "8":
        this.state = {
          active: -1,
          clicked: -1,
          menus: menus_disaan,
          };
          break;
      default:
         if(localStorage.accesos){
          let accesos = JSON.parse(localStorage.accesos);
         
          let orden_accesos = this.handleOrden(accesos);
          
            let menus_acceso = [];
            orden_accesos.find(acceso=>{
            let mc = menus_cliente[acceso.description];
              if(mc){
                mc.find(elemento=>{
                  menus_acceso.push(elemento); 
                });
              }
            });
        
            this.state = {
              active: -1,
              clicked: -1,
              menus:menus_acceso.filter((e, i) => menus_acceso.findIndex(a => a["title"] === e["title"]) === i)
            };
          }else{
            this.state = {
              active: -1,
              clicked: -1,
              menus:[]
            };
          }
        break; 
    }

    this.handleSidebarSearch = this.handleSidebarSearch.bind(this);
  }
  
 
  handleExpand(e, i, match) {
    e.preventDefault();

    if (this.state.clicked === -1 && match) {
      this.setState((state) => ({
        active: -1,
        clicked: 1,
      }));
    } else {
      this.setState((state) => ({
        active: this.state.active === i ? -1 : i,
        clicked: 1,
      }));
    }
  }

  handleSidebarSearch(e) {
    let searchValue = e.target.value;
    searchValue = searchValue.toLowerCase();

    this.setState((state) => {
      let newMenus = [];
      if (searchValue !== "") {
        newMenus = menus.filter((item) => {
          let title = item.title;
          title = title.toLowerCase();
          if (title.search(searchValue) > -1) {
            item.search = true;
            return true;
          } else {
            if (item.children) {
              for (var i = 0; i < item.children.length; i++) {
                let title2 = item.children[i]["title"];
                title2 = title2.toLowerCase();

                if (title2.search(searchValue) > -1) {
                  item.search = true;
                  return true;
                }
              }
            }
            return false;
          }
        });
      } else {
        newMenus = menus.filter((item) => {
          item.search = false;
          return true;
        });
      }
      return {
        menus: newMenus,
      };
    });
  }

  handleOrden(array_accesos){
    let ordenado = [];
    let primero = {};
    let ultimo = {};

    for(let i in array_accesos){
      if(array_accesos[i].id === "3"){
        ultimo = array_accesos[i];
      }else if(array_accesos[i].id === "4"){
        primero = array_accesos[i];
      }else{
        ordenado.push(array_accesos[i]);
      }
    }

    if (JSON.stringify(primero)!=='{}'){ ordenado.unshift(primero); }

    if (JSON.stringify(ultimo)!=='{}'){ ordenado.push(ultimo)  };

    return ordenado;
  }

  render() {
    return (
      <ul className="nav">
        {this.context.pageSidebarSearch && (
          <li className="nav-search">
            <input
              type="text"
              className="form-control"
              placeholder="Sidebar menu filter..."
              onKeyUp={this.handleSidebarSearch}
            />
          </li>
        )}
        <li className="nav-header">Navegación</li>
        {this.state.menus.map((menu, i) => (
          <Route
            path={menu.path}
            exact={menu.exact}
            key={i}
            children={({ match }) => (
              <SidebarNavList
                data={menu}
                key={i}
                expand={(e) => this.handleExpand(e, i, match)}
                active={i === this.state.active}
                clicked={this.state.clicked}
              />
            )}
          />
        ))}
      </ul>
    );
  }
}

//export default SidebarNav;

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <SidebarNav auth={auth} history={history} {...props} />;
};
